/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


document.addEventListener('DOMContentLoaded', function () {
  const searchControlinput = document.querySelector(".search-control");
  const searchBtn = document.querySelector(".search-btn");
  var attributes = JSON.parse(searchBtn.dataset.gutenbergAttributes);
  const searchlist = document.querySelector(".search-list");
  const checkboxes = document.querySelectorAll('.search-list input[type="checkbox"]');
  const resultsContainer = document.querySelector(".searchrecord");
  var newValue;
  var commaSeparatedValues;
  const currentPage = parseInt(getParameterByName('paging'), 10);
  const postsPerPage = attributes.searchPerPage;
  let indexOfLastPost = currentPage * postsPerPage;
  let indexOfFirstPost = indexOfLastPost - postsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  let lastSearch = getParameterByName('q');
  let postType = getParameterByName('post_types');
  let taxonomies = getParameterByName('taxonomies');
  let paging = getParameterByName('paging');



  setInterval(function () {


    if (lastSearch != getParameterByName('q')) {
      window.location.reload();
    }

    if (postType != getParameterByName('post_types')) {
      window.location.reload();
    }

    if (taxonomies != getParameterByName('taxonomies')) {
      window.location.reload();
    }


  }, 2000);


  function getParameterByName(name, url) {
    if (!url) url = document.URL;

    var urlWithoutOrigin = url.substring(url.indexOf('?'));
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(urlWithoutOrigin);
    if (!results) return null;
    var encodedValue = results[2] ? decodeURIComponent(results[2].replace(/\+/g, ' ')) : '';
    return encodedValue;
  }


  const getPostTypesFromUrl = () => {


    const queryParam = '?q=' + getParameterByName('q') +
      '&post_types=' + getParameterByName('post_types') +
      '&taxonomies=' + getParameterByName('taxonomies') +
      '&paging=' + getParameterByName('paging') +
      '&per_page=' + getParameterByName('per_page');

    const urlParams = new URLSearchParams(queryParam);

    if (urlParams != '') {

      const PostTypeParam = urlParams.get('post_types');
      const PostTypeItems = PostTypeParam.split(',');
      const TaxTypeParam = urlParams.get('taxonomies');
      const TaxTypeItems = TaxTypeParam.split(',');

      PostTypeItems.forEach(value => {
        $(`button[name="post_check[]"][value="${value}"]`).addClass('checked');
      });

      TaxTypeItems.forEach(value => {
        $(`button[name="tax_check[]"][value="${value}"]`).addClass('checked');
      });


    }


  };

  getPostTypesFromUrl();


if (resultsContainer) {
  resultsContainer.addEventListener('click', function (event) {
    const target = event.target;

    if (target.classList.contains('page-link-item')) {

      newValue = getParameterByName('q');

      const postCheck = document.querySelectorAll('.post-check.checked');
      const allPostCheck = Array.from(postCheck).map(button => button.value).join();
      const taxCheck = document.querySelectorAll('.tax-check.checked');
      const allTaxCheck = Array.from(taxCheck).map(button => button.value).join();


      const pageNumber = parseInt(target.getAttribute('data-page'));

      const url = new URL(document.URL);
      url.searchParams.set('q', newValue);
      url.searchParams.set('post_types', allPostCheck);
      url.searchParams.set('taxonomies', allTaxCheck);
      url.searchParams.set('paging', pageNumber);

      window.history.pushState({}, '', url);
      window.location.reload();

    }
  });

} 

  

  const searchresulthtml = (data) => {

    let concatenatedTitles = '';
    const searchTerm = getParameterByName('q');
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const totalPages = Math.ceil(data.length / postsPerPage);
    const currentPosts = data.slice(indexOfFirstPost, indexOfLastPost);


    if (data.length > 0) {
      concatenatedTitles += ` 
      <p class="mb-2">You searched for: ${searchTerm}</p>
      <p class="mb-md-6 mb-4">
        We found ${data.length} results
      </p>`;

      currentPosts.forEach((item) => {
        const capitalizedPostType = item.post_type.charAt(0).toUpperCase() + item.post_type.slice(1);


        concatenatedTitles +=
          `<div key="${item.id}" class="search-list mb-3 bg-light-200 p-4">
          <p class="d-flex gap-2 mb-2">
            <span>${item.dates}</span>`;
        <i>-</i>
        if (attributes.enableposttype) {
          concatenatedTitles += `<span>${capitalizedPostType}</span>`;
        }

        concatenatedTitles += `</p>
        
      `;

        if (attributes.enableTitle) {
          concatenatedTitles += `<h${attributes.headingTagLevel} class="richtext-heading fw-medium text-${attributes.headingApperance}">
          <a href="${item.permalink}" rel="noopener" target="_${attributes.ReadMoreTarget}">${item.title}</a>
        </h${attributes.headingTagLevel}>`;
        }

        concatenatedTitles += ``;

        if (attributes.enableDescription) {
          concatenatedTitles += `<p class="richtext-paragraph text-${attributes.paragraphApperance}">${item.description.length > attributes.descriptionLength ? item.description.slice(0, attributes.descriptionLength) + '...' : item.description}</p>`;
        }

        concatenatedTitles += `
          <a href="${item.permalink}" rel="noopener" target="_${attributes.ReadMoreTarget}" class="read-more-link align-items-center ${attributes.ReadMoreIcon}">
            ${attributes.readmoretext}  
          </a>`;
        concatenatedTitles += "</div>";
      });

      if (data.length > postsPerPage) {
      const paginateHtml = `<nav aria-label="Page navigation">
  <ul class="pagination pagination-filter mt-4">
    <li class="page-item me-auto">
      <a class="page-icon ${currentPage === 1 ? 'disabled' : 'page-link-item'} page-prev d-flex align-items-center border-0" data-page="${currentPage - 1}">
      <i class="cta-with-icon me-3"></i> Previous
      </a>
    </li>
    ${Array.from({ length: totalPages }, (_, index) => {

        if (
          index === 0 ||
          index === totalPages - 1 ||
          index === currentPage - 1 ||
          index === currentPage - 2 ||
          index === currentPage ||
          index === currentPage + 1
        ) {
          return `
          <li class="page-item ${index + 1 === currentPage ? 'active' : ''}">
            <a class="page-link page-link-item" data-page="${index + 1}">${index + 1}</a>
          </li>`;
        } else if (
          index === 1 && currentPage - index > 2
        ) {
          return `
          <li class="page-item disabled">
            <a class="page-link page-link-item">...</a>
          </li>`;
        } else if (
          index === totalPages - 2 && index - currentPage > 2
        ) {
          return `
          <li class="page-item disabled">
            <a class="page-link page-link-item">...</a>
          </li>`;
        }
      }).join('')}
   <li class="page-item ms-auto">
  <a class="page-icon ${currentPage === totalPages ? 'disabled' : 'page-link-item'}  page-next d-flex align-items-center border-0" data-page="${currentPage + 1}" >
  Next <i class="cta-with-icon ms-3"></i> 
     </a>
</li>

  </ul>
</nav>`;


      concatenatedTitles += paginateHtml;
    }
    } else {

      concatenatedTitles += `<p>No records found</p>`;
    }

    resultsContainer.innerHTML = concatenatedTitles; // phpcs:ignore WordPressVIPMinimum.JS.InnerHTML.Found
  };


  const handleSearch = async () => {


    const searchTerm = getParameterByName('q');
    indexOfLastPost = currentPage * postsPerPage;
    indexOfFirstPost = indexOfLastPost - postsPerPage;

    const postCheck = document.querySelectorAll('.post-check.checked');
    const allPostCheck = Array.from(postCheck).map(button => button.value).join();
    const taxCheck = document.querySelectorAll('.tax-check.checked');
    const allTaxCheck = Array.from(taxCheck).map(button => button.value).join();



    try {
      let url = `${attributes.baseURL}/wp-json/custom/v1/search?q=${searchTerm}&post_types=${allPostCheck}`;
      url += `&taxonomies=${allTaxCheck}`;
      url += `&paging=1`;

      const response = await fetch(url);
      const data = await response.json();
      searchresulthtml(data)
    } catch (error) {
      console.error("Error fetching search data:", error);
    }
  };


  var checkboxButtons = document.getElementsByClassName('checkbox-button');
  var checkedValues = [];

  Array.from(checkboxButtons).forEach(function (button) {
    button.addEventListener('click', function () {

      

      var isChecked = this.getAttribute('aria-checked') === 'true';
      this.setAttribute('aria-checked', !isChecked);
      this.classList.toggle('checked');

      if (isChecked) {
        checkedValues = checkedValues.filter(value => value !== this.value);
      } else {
        checkedValues.push(this.value);
      }

      newValue = getParameterByName('q');
      const postCheck = document.querySelectorAll('.post-check.checked');
      const allPostCheck = Array.from(postCheck).map(button => button.value).join();
      const taxCheck = document.querySelectorAll('.tax-check.checked');
      const allTaxCheck = Array.from(taxCheck).map(button => button.value).join();
      const pageNumber = 1;

      const url = new URL(document.URL);
      url.searchParams.set('q', newValue);
      url.searchParams.set('post_types', allPostCheck);
      url.searchParams.set('taxonomies', allTaxCheck);
      url.searchParams.set('paging', pageNumber);

      window.history.pushState({}, '', url);

      window.location.reload();

    });
  });


  var searchTerm = getParameterByName('q');
  if (searchTerm) {
    const searchResultsHtml = handleSearch();
  }

  const btns = document.querySelectorAll('.search-btn');
  const textareas = document.querySelectorAll('.search-control');
  const searchBtns = document.querySelectorAll(".search-btn");
  const searchBtnText = document.querySelectorAll(".search-text");

  btns.forEach((btn, index) => {
    var attributes = JSON.parse(btn?.dataset?.gutenbergAttributes);
    const placeholderText = attributes.placeholdertext;

    textareas[index].placeholder = placeholderText;


    document.getElementById('myTextarea').addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        searchBtns[index].click();
      }
    });

    if (searchBtnText[index]) {
      searchBtnText[index].addEventListener("click", async function (event) {

        const textareaValue = textareas[index].value.trim();

        if (!textareaValue) {
          return false;
        }

        if (attributes.enableFilter === false) {
          let url;

          if (attributes.enableRedirect === true) {
            url = new URL(`/${attributes.redirectPageName}/`, document.URL);
          } else {
            url = new URL(`/search-results/`, document.URL);
          }

          url.searchParams.set('q', textareaValue);
          url.searchParams.set('post_types', '');
          url.searchParams.set('taxonomies', '');
          url.searchParams.set('paging', 1);
          url.searchParams.set('per_page', '');

          window.history.pushState({}, '', url);
          window.location.reload();
          return;
        } else {
          const url = new URL(document.URL);
          url.searchParams.set('q', textareaValue);
          url.searchParams.set('post_types', '');
          url.searchParams.set('taxonomies', '');
          url.searchParams.set('paging', 1);
          url.searchParams.set('per_page', '');

          window.history.pushState({}, '', url);
          window.location.reload();
          return;
        }
      })
    }



    searchBtns[index].addEventListener("click", async function (event) {
      const textareaValue = textareas[index].value.trim(); 
    
      if (!textareaValue) { 
        return false;
      }
    
      if (attributes.enableFilter === false) {
        let url;
    
        if (attributes.enableRedirect === true) {
          url = new URL(`/${attributes.redirectPageName}/`, document.URL);
        } else {
          url = new URL(`/search-results/`, document.URL);
        }
    
        url.searchParams.set('q', textareaValue);
        url.searchParams.set('post_types', '');
        url.searchParams.set('taxonomies', '');
        url.searchParams.set('paging', 1);
        url.searchParams.set('per_page', '');
    
        window.history.pushState({}, '', url);
        window.location.reload();
        return;
      } else {
        const url = new URL(document.URL);
        url.searchParams.set('q', textareaValue);
        url.searchParams.set('post_types', '');
        url.searchParams.set('taxonomies', '');
        url.searchParams.set('paging', 1);
        url.searchParams.set('per_page', '');
    
        window.history.pushState({}, '', url);
        window.location.reload();
        return;
      }
    })


    textareas[index].addEventListener('keydown', function (event) {

      if (event.keyCode === 13) {
        event.preventDefault();
      }
    });


    if (textareas[index] && searchTerm !== null && searchTerm !== undefined) {
      textareas[index].value = searchTerm;
    }


  });

});
